import React, { FC, ComponentType } from 'react';
import { Button, ButtonProps } from '@mui/material';
import styled from 'styled-components';
import { COLORS } from '../assets/colors';

interface JoinedClubButtonProps extends ButtonProps {
  loading?: boolean;
}

const JoinedClubButton: FC<JoinedClubButtonProps> = ({ loading, ...rest }) => (
  <StyledButton {...rest}>Joined</StyledButton>
);

JoinedClubButton.defaultProps = {
  loading: false,
};

export default JoinedClubButton;

const StyledButton = styled(Button).attrs({
  variant: 'contained',
  color: 'primary',
  size: 'small',
})`
  align-self: center;
  padding: 0;
  font-size: 12px;
  border-radius: 4px;
  height: 24px;
  min-width: 64px;

  &.MuiButton-containedPrimary {
    background-color: ${COLORS.lightBlue};
  }
` as ComponentType<ButtonProps>;
